import { z } from 'zod';

export const BundleAssignmentForcedReasonSchema = z.enum([
  'STATUTORY',
  'TELECOM',
  'CARD_INVOICE',
  'REGISTERED_CARD_PAYMENT',
  'USER_SEPARATE_BILLS',
]);
export type BundleAssignmentForcedReason = z.infer<typeof BundleAssignmentForcedReasonSchema>;

export const BundleAssignmentDecisionActionSchema = z.enum([
  'LINK_EXISTING_BILL',
  'GROUP_NEW_BILL',
  'CREATE_NEW',
]);
export type BundleAssignmentDecisionAction = z.infer<typeof BundleAssignmentDecisionActionSchema>;

export const BundleAssignmentDecisionItemSchema = z.object({
  documentId: z.string().uuid(),
  itemIndex: z.number().int().min(0),
  action: BundleAssignmentDecisionActionSchema,
  targetBillId: z.string().uuid().nullable(),
  bundleGroupId: z.string().min(1).max(40).nullable(),
  forcedReason: BundleAssignmentForcedReasonSchema.nullable(),
  confidence: z.number().min(0).max(100),
  reasoning: z.string().max(600),
  recurringTemplateSuggestion: z
    .object({
      shouldSuggest: z.boolean(),
      vendorRecurringBillId: z.string().uuid().nullable(),
      notes: z.string().max(500).nullable().optional(),
    })
    .optional(),
});
export type BundleAssignmentDecisionItem = z.infer<typeof BundleAssignmentDecisionItemSchema>;

export const BundleAssignmentDecisionSchema = z.object({
  bundleId: z.string().uuid(),
  version: z.literal(1),
  summary: z.string().max(1000),
  items: z.array(BundleAssignmentDecisionItemSchema),
  producedBy: z.enum(['PLANNER', 'REVIEWER']),
  producedAt: z.string().datetime(),
  /** Vendor instruction versions (`ap_vendor_knowledge`) the planner and reviewer were shown. */
  vendorInstructionKnowledgeIds: z.array(z.string().uuid()).optional(),
});
export type BundleAssignmentDecision = z.infer<typeof BundleAssignmentDecisionSchema>;

export const BundleAssignmentReviewItemSchema = BundleAssignmentDecisionItemSchema.extend({
  reviewerOverride: z
    .object({
      previousAction: BundleAssignmentDecisionActionSchema,
      reason: z.string().max(600),
    })
    .nullable(),
});
export type BundleAssignmentReviewItem = z.infer<typeof BundleAssignmentReviewItemSchema>;

export const BundleAssignmentReviewSchema = BundleAssignmentDecisionSchema.extend({
  items: z.array(BundleAssignmentReviewItemSchema),
  reviewNotes: z.string().max(2000),
});
export type BundleAssignmentReview = z.infer<typeof BundleAssignmentReviewSchema>;
